<template>
	<div class="inf_wrap">
		<p class="back_box" @click="back()">
			<img src="../../../static/images/back.png" alt=""> 返回上一页
		</p>
		<h2>查看报价及方案</h2>
		<ParheaderVue :caseid="caseid" :token="token" />
		<div class="box_req">
			<h3>回复方案及报价详情</h3>
			<div class="req_box">
				<p><b>救援方案</b></p>
				<div class="acc_box">
					<p>附件({{acc_list.length}})</p>
					<attaList :attaArr="acc_list"></attaList>
				</div>
			</div>
			<div class="offer_box">
				<p><b>整体救援报价</b></p>
				<p class="allMoney">
					<span>救援报价：<b>{{obj.rescueFee + obj.medicFee}} {{obj.currency}}</b></span>
					<span> 救援费用：<b>{{obj.rescueFee||0}} {{obj.currency}}</b></span>
					<span>医疗费用：<b>{{obj.medicFee||0}} {{obj.currency}}</b></span>
				</p>
			</div>
			<div class="rescue_box" v-for="(item,ind) in checkList" :key="ind">
				<p>{{item.name}}</p>
				 <fuwuqingdan :attaArr=item.list></fuwuqingdan>
			</div>
			<div class="ex_box">
				<!-- <textarea name="exp" id="exp" cols="30" rows="10" v-model="exp" placeholder="添加说明"> -->
				<p>添加说明:</p>
				<changeLanguage  v-model='exp'></changeLanguage>
            </textarea>
			</div>
      <template v-if="false">
         <p style="padding: 5px 0;"><b>短信验证码</b></p>
        <div class="codeDiv">
          <el-input placeholder="请输入短信验证码" v-model="codePhoto"></el-input>
          <el-button type="primary" @click='sendCode' :disabled="sendBtn">{{sendText}}</el-button>
        </div>
      </template>

			<div class="upbtn_box">
				<el-button type="primary" @click="apply(1)">授权通过，启动救援</el-button>
				<el-button type="primary" @click="apply(2)">拒绝救援</el-button>
				<!-- span @click="toalter">修改报价</span -->
			</div>
		</div>
	</div>
</template>

<script>
	import qs from "qs";
	import { Message } from "element-ui";
	import err from "@/util/error2msg.js";
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import ParheaderVue from "../par/parheader.vue";
	import attaList from "@/components/attachment/index1";
	import fuwuqingdan from "@/components/attachment/qingdan1";
	import changeLanguage from '@/components/common/changeLange.vue'
  import { smsOperation } from '@/views/axios/api.js'
	export default {
		components: {
			ParheaderVue,
			attaList,
			fuwuqingdan,
			changeLanguage
		},
		data() {
			return {
				exp: '',
				token:JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				acc_list: [],
				formInline: {
					user: "",
					region: ""
				},
				checkList: [],
				parentObj: [],
				obj: {
					totalFee: 0,
					rescueFee: 0,
					medicFee: 0,
					caseFee: 0
				},
				contractType: 1,
        codePhoto:'',
        sendText:'发送验证码',
        timer:null,
        sendBtn:false
			};
		},
		methods: {
			error2msg(errcode) {
				var errmsg = err;
				var msg = errmsg.tomsg(errcode);
				Message.error(msg);
			},
			back() {
				this.$router.push("/regulator/caseindex/offer?typeId=" + this.$route.query.typeId);
			},
      sendCode(){
        smsOperation({token:this.token})
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.sendBtn=true
            this.$message.success('发送成功')
            var time =120
            this.timer=setInterval(()=> {
              time--
                if(time <= 0){
                  this.sendText='发送验证码';
                  this.sendBtn=false
                }else{
                  this.sendText=`${time}s重试`
                }
            },1000)
          }else if(res.data.code == '200012'){
            this.$message.error('短信发送频率过快')
          }else if(res.data.code == '200030'){
            this.$message.error('手机号未绑定')
          }else if(res.data.code == '200002'){
            this.$message.error('手机号未找到')
          }else{
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
			apply(num) {
        // if(this.codePhoto == '') return this.$message.error('请先获取短信验证码')
				let that = this;
				this.axios
					.post(
						constants.domain + "rescue/bidding/authorize_solution",
						qs.stringify({
							token: this.token,
							caseId: this.caseid,
							status: num,
							stateText3: this.exp,
              // checkCode:this.codePhoto
						})
					)
					.then(res => {
						console.log(res.data);
						if(res.data.code === 0) {
							if(num == 1){
									Message({
									message: "授权成功",
									type: "success"
								});
								that.$router.push({
									path: "/regulator/caseindex/resstepGoing",
									name: "resstepGoing",
									params: {
										token: that.token,
										obj: that.inf,
										data: that.obj
									},
									query: {
										typeId: that.$route.query.typeId,
										caseid:that.$route.query.caseid
									}
								});
							}else{
								Message({
									message: "案件已拒绝",
									type: "success"
								});
								this.$router.go(-1)
							}

						} else {
							that.error2msg(res.data.code);
						}
					});
			},
			toalter() {
				this.$router.push("/regulator/caseindex/alter?typeId=" + this.$route.query.typeId);
			}
		},
		mounted() {
			let that = this;
			let n = 0;

			fetch(constants.domain + "rescue/case/detail_case", {
					method: "POST",
					body: `token=${this.token}&caseId=${this.caseid}`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					if(data.code == 0) {
						that.contractType = data.obj.obj.contractType || 1;
					}
				});

			fetch(
					constants.domain + "rescue/bidding/view_case_solution", {
						method: "POST",
						body: `token=${this.token}&caseId=${this.caseid}&state=4`,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}
				)
				.then(function(res) {
					//console.log(res);
					return res.json();
				})
				.then(function(data) {
					that.obj = data.obj
					data.obj2.map(v => {
						if(v.dict.parentId == "0") {
							var obj = {};
							obj.id = v.dict.parentId;
							obj.childId = v.dict.id;
							obj.name = v.dict.name;
							obj.list = [];
							that.checkList.push(obj);
						} else {
							that.checkList.map(o => {
								if(v.dict.parentId == o.childId) {
									//console.log(v.dict.parentId)
									o.list.push(v);
								}
							});
						}
					});
					//获取救援方案
					fetch(constants.domain + "rescue/case/upload_cnts", {
							method: "POST",
							body: `token=${that.token}&objId=${data.obj.caseId}&caseId=${that.$route.query.caseid}&objType=1`,
							mode: "cors",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						})
						.then(function(res) {
							//console.log(res);
							return res.json();
						})
						.then(function(data) {
							data.obj.map(v => {
								if(constants.isPic(v.url)) {
									v.icon = v.url;
								} else {
									v.icon = '../../../static/images/eles_icon.png';
								}
								that.acc_list.push(v);
							});
						});

				});
		}
	};
</script>

<style scoped>
	@import url(../../css/lookinf.css);
	h2 {
		font-size: 18px;
	}

	.box_req {
		margin-left: 35px;
	}

	.box_req h3 {
		font-size: 16px;
		line-height: 50px;
	}

	.req_box {
		margin-left: 35px;
	}

	.acc_box {
		margin-left: 35px;
	}

	.offer_box {
		margin-left: 35px;
	}
	.offer_box b{font-size: 16px;}
	.allMoney {
		margin-left: 35px;
	}

	.allMoney span {
		margin-right: 20px;
	}
	.ex_box{margin-left: 70px;}
	.ex_box p{margin-bottom: 10px;}
   .codeDiv{width: 450px;margin-left: 50px;}
  .codeDiv .el-input{width: 300px;}
</style>



// WEBPACK FOOTER //
// src/components/regulator/Lookinf.vue